import React from "react";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import PropTypes from "prop-types";

import Link from "../../assets/images/Link.svg";

import CustomButton from "../CustomButton/CustomButton";
import kasabay from "../../assets/images/kasabay.png";

const CustomCarousel = ({ isMobile }) => {
  const projects = [
    {
      image: kasabay,
      header: "Kasabay - in the works",
      description: `
      A passion project of mine to address the greyzone of carpooling in the Philippines. Currently, still in development and in discussion with LTFRB (fingers crossed). Message me if you want to know more :)
		`,
      button: {
        text: "View Site (soon)",
        url: "https://google.com",
      },
    },
    {
      image:
        "https://www.stagwellglobal.com/wp-content/uploads/2021/11/logos_NRG-black.svg",
      header: "National Research Group",
      description: `
      Software engineer for multiple projects. Conducted technical debt assessments whilst balancing improvements and ensuring long-term maintainability without disrupting delivery timelines.
		`,
      button: {
        text: "View Site",
        url: "https://shopee.ph",
      },
    },
    {
      image:
        "https://deo.shopeemobile.com/shopee/shopee-pcmall-live-sg/assets/ca5d12864c12916c05640b36e47ac5c9.png",
      header: "Shopee",
      description: `
			Full stack engineer under
			Business Technologies. Developed and spearheaded countless tools used by multiple departments in the company ranging from spx, marketing, business development, etc.
		`,
      button: {
        text: "View Site",
        url: "https://shopee.ph",
      },
    },
    {
      image:
        "https://storage.googleapis.com/studio-design-asset-files/projects/9YWy0wVYaM/s-285x24_82f5d540-ff8f-4542-9e29-cdb08dbfd792.svg",
      imageStyle: {
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
      },
      header: "Hackazouk",
      description: `
			Full stack developer for the flagship product https://official-alumni.com/ . Delved heavily on both front end and back end aspects of the development life cycle of our product.
		`,
      button: {
        text: "View Site",
        url: "https://www.hackazouk.com/",
      },
    },
    {
      image: "https://i.imgur.com/r2iV5Xj.png",
      header: "Audiohub.ph",
      description:
        "A waterfall based freelance project where I developed an ecommerce system from the ground up - both front end and back end - both customer and seller side. Site hosted on my homelab server tunnelled with wireguard.",
      button: {
        text: "View Site",
        url: "https://audiohub.ph",
      },
    },
    {
      image:
        "https://assets.rappler.com/BA2971912D0E4F10825163812D706961/img/7248FDF4C5D84EF9B44CA8830FC44A9B/spark-philippines-pledge-website-october-10-2019-001_7248FDF4C5D84EF9B44CA8830FC44A9B.jpg",
      header: "Spark - Non Profit Bidding",
      description:
        "Developed an interface that allows stakeholders to bid and for organizations to garner funds for their cause. Currently non-operational but was featured in a news article",
      button: {
        text: "View Article",
        url: "https://r3.rappler.com/move-ph/242210-pledge-site-girl-empowerment",
      },
    },
  ];

  const projectsList = projects.map(
    (
      { image, header, description, button: { text, url }, imageStyle = {} },
      i,
    ) => (
      <div key={i} className="customCarousel__item">
        <div
          className="customCarousel__item__img"
          style={{
            backgroundImage: `url(${image})`,
            backgroundPosition: "center",
            ...imageStyle,
          }}
        />
        <h3>{header}</h3>
        <p>{description}</p>
        <CustomButton
          onClick={() => {
            window.open(url, "_blank");
          }}
          image={Link}
        >
          {text}
        </CustomButton>
      </div>
    ),
  );

  return (
    <div className="customCarousel">
      {projectsList}
      <Carousel
        centerMode={!isMobile}
        centerSlidePercentage={50}
        infiniteLoop
        autoPlay
        interval={2000}
        showThumbs={false}
      >
        {projectsList}
      </Carousel>
    </div>
  );
};

CustomCarousel.propTypes = {};

export default CustomCarousel;
